module.exports = __webpack_public_path__ + "static/media/contactlensesColor2.7f84f778.jpg";